import React, { useCallback, useEffect, useRef, useState } from 'react';

import { Guid } from '../../../../store/model/guid';
import { WidgetDataRepository } from '../../../../store/repository/widgets/widgetDataRepository';
import { ignorePromise, WidgetType } from '@ael/core-api';

interface MediaLibrarySingleAssetProviderProps<T> {
  assetId: Guid;
  widgetId: Guid;
  widgetType: WidgetType;

  children: (data?: T) => React.ReactNode;
}

interface MediaLibrarySingleAssetProviderState<T> {
  data?: T;
}

export const MediaLibrarySingleAssetProvider = <T,>(props: MediaLibrarySingleAssetProviderProps<T>) => {
  const [data, setData] = useState<MediaLibrarySingleAssetProviderState<T>>({ data: undefined });
  const prevProps = useRef<MediaLibrarySingleAssetProviderProps<T>>();

  const fetchData = useCallback(
    async (assetId: string) => {
      await WidgetDataRepository.getWidgetData({ assetId }, props.widgetType, props.widgetId).then((data) => {
        const assetData = data as T;
        setData({
          data: assetData,
        });
      });
    },
    [props.widgetId, props.widgetType]
  );

  useEffect(() => {
    if (prevProps.current?.assetId !== props.assetId) {
      ignorePromise(fetchData(props.assetId));
    }
    prevProps.current = props;
  }, [fetchData, props]);

  return <>{props.children(prevProps.current?.assetId === props.assetId ? data.data : undefined)} </>;
};
